import type { AxiosRequestConfig } from 'axios'

import type { SiteId } from '@beaded/models'

import * as apiUtils from '.'

export type SeaIceGroupName = 'near' | 'long'

export interface SeaIceFeature {
  type: 'Feature'
  properties: { z: number; validDate?: string }
  geometry: { type: 'Polygon'; coordinates: number[][][] }
}

export interface SeaIceFeatureCollection {
  type: 'FeatureCollection'
  features: SeaIceFeature[]
}

export interface SeaIceHorizon {
  z: number
  validDate: string | null
  featureCollection: SeaIceFeatureCollection
}

export interface SeaIceGroup {
  group: SeaIceGroupName
  leadDays: number[]
  dataDate: string | null
  completedAt: string | null
  stale: boolean
  horizons: SeaIceHorizon[]
}

export interface SeaIceForecastResponse {
  siteId: number
  generatedAt: string
  groups: SeaIceGroup[]
}

export const getForSite = (
  siteId: SiteId | number,
  options: AxiosRequestConfig = {},
): Promise<SeaIceForecastResponse> =>
  apiUtils.GET(`/sea-ice-forecast/site/${siteId}`, options)
